import { useEffect } from 'react';
import { useOrientationStore } from "../../stores/orientationStore";


export function CheckLandscape() {
  const setIsLandscape = useOrientationStore.getState().setIsLandscape;

  useEffect(() => {
    const handleResize = () => {
      const isLandscape = window.innerWidth > window.innerHeight;
      setIsLandscape(isLandscape);
    };

    // control for first time
    handleResize();

    // Listen resize event
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setIsLandscape]);

  return null; // no UI
}
